export default "__VITE_ASSET__CvYipsKK__"